/**
 * iter87.465.22 (user-directed — "Only NCAA March madness and KO World
 * Cup would have a draft... default templates are not draft. Fix
 * correctly. No bedside again.") — SINGLE SOURCE OF TRUTH, positive
 * whitelist of templates with a genuine admin-run snake draft.
 *
 * Previously `StartDraftBanner.jsx` and `AdminPanel.jsx` each kept
 * their OWN blacklist (every template EXCEPT a growing exclusion
 * list) — the two lists drifted apart and both missed MLS Playoffs,
 * which is how the "Draft" tile kept recurring on templates that
 * don't support it. Every new playoffs/pot template added from here
 * is "no draft" by default — nothing to add, nothing to forget.
 *
 * `golf_position_draft_api` is intentionally NOT in this set — it
 * gets its own info-only "auto-draft at tee-off" tile, checked
 * separately wherever this set is consumed.
 */
export const DRAFT_ELIGIBLE_TEMPLATES = new Set([
    "custom",
    "march_madness",
    "world_cup_ko_api",
]);

/**
 * iter87.465.22 — The ONE gate every draft-CTA surface (AdminPanel's
 * Draft tab, the dashboard StartDraftBanner, HeroStrip's Start/Join
 * Draft buttons) must call, instead of each re-deriving its own
 * boolean. `golf_position_draft_api` is deliberately NOT eligible here
 * (it auto-drafts server-side at tee-off, no manual CTA anywhere) —
 * callers that need its separate info-only admin tile check that
 * template directly, same as before.
 */
export function isDraftEligible(tournament) {
    if (!tournament) return false;
    if (tournament.completion_authorized_by) return false;
    if (tournament.lifecycle_state === "final") return false;
    if (!DRAFT_ELIGIBLE_TEMPLATES.has(tournament.template)) return false;
    if ((tournament.pickem || {}).mode === "pot") return false;
    return true;
}
